import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import Loader from "../../components/Loader";
import { login, loginPageRoles } from "../../modules/user/redux/action";
import "../../style";
import Button from "../FormElement/Button";
import { validForm } from "../FormElement/FormValidator";
import InputFiled from "../FormElement/InputFiled";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';  // Import MenuItem

class UserLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        email: "",
        password: "",
      },
      formErrors: {
        email: "",
        password: ""
      },
      roles:[
        {
          name:"Farmer"
        },
        {
          name:"Truckline"
        },
        {
          name:"Counterparty"
        }
      ],
      isValid: true,
      invalidUser: {},
      isEnabled: false,
      reDirect: false,
      fetchingComplete: true,
      selectedRole: "Farmer"
    };
  }
 
  componentDidMount () {
    // loginPageRoles()
    // .then((res)=>{
    //   this.setState({roles:res})
    // }) 
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.loginError &&
      nextProps.loginError !== this.props.loginError
    ) {
      this.setState({
        invalidUser: nextProps.loginError,
        fetchingComplete: true
      });
    }
    console.log(nextProps.enableUser);
    if (
      nextProps.enableUser &&
      nextProps.enableUser !== this.props.enableUser
    ) {
      this.setState({
        isEnabled: nextProps.enableUser.isEnabled
      });
    }
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      prevState => {
        return {
          user: {
            ...prevState.user,
            [name]: value
          },
          fetchingComplete: true
        };
      },
      () => {
        const { user } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, user)
        });
      }
    );
  };
  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { user } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, user),
          invalidUser: ""
        });
      }
    );
  };
  handleDropdownChange = (event) => {
    this.setState(
     {   
          selectedRole: event.target.value
        
      }
    )
    localStorage.setItem("userRole",event.target.value)
  };

  userSignin = e => {
    e.preventDefault();
    this.setState({ fetchingComplete: false });
    const { user, isValid } = this.state;
    if (!isValid) {
      this.props.login(user);
    }
  };

  render() {
    const {
      user,
      isValid,
      invalidUser,
      isEnabled,
      reDirect,
      fetchingComplete,
      roles,
    } = this.state;
    const { loginError = {} } = this.props;

    if (isEnabled) {
      return <Redirect to="/subscription" />;
    }

    if (!fetchingComplete) {
      return <Loader />;
    }

    if (
      loginError.error_description === "User is disabled" &&
      loginError.codeId !== null &&
      !!!loginError.subscriptionEntity
    ) {
      return <Redirect to={`/subscription?codeId=${loginError.codeId}`} />;
    }
    return (
      <div className="">
        <div className="textRequired">* Required Cells</div>
        <div className="mainform">
          <form noValidate ref={form => (this.form = form)}>
          <p className="loginHeader">Log in</p>     
            <InputFiled
              placeholder="example@mail.com"
              label="Email/Username"
              type="email"
              name="email"
              value={user.email}
              handleChange={this.handleChange}
              validations={["email", "required"]}
              handleError={this.handleError}
              required
            />
            <InputFiled
              placeholder="Password"
              label="Password"
              type="password"
              name="password"
              value={user.password}
              handleChange={this.handleChange}
              validations={["password", "required"]}
              handleError={this.handleError}
              required
            />
            {invalidUser && invalidUser.error_description && (
              <div className="error">{invalidUser.error_description}</div>
            )}
            
            <Link to="/forgot-password" style={{ color: "blue" }}>
              Forgot Password?
            </Link>
            <div className="loginButtonContainer">
              <Button
                name="Log in"
                disabled={isValid}
                onclick={this.userSignin}
                styleClass="signIn"
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    user: state,
    enableUser: state.user,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    loginError: state.user.loginError
  };
}

export default connect(
  mapStateToProps,
  { login }
)(UserLogin);



// WEBPACK FOOTER //
// ./src/components/public/UserLogin.js